import { BotProvider, useGetApiBotProviderList, usePostApiBotProviderCreate, usePostApiBotProviderImport } from "@/API"
import { Button, Group, LoadingOverlay, Stack } from "@mantine/core"
import { BotProviderCard } from "./BotProviderCard"
import { useQueryClient } from "@tanstack/react-query"
import { notifications } from "@mantine/notifications"
import { BotProviderCreateButton } from "./BotProviderCreateButton"
import { AutoResetFileButton } from "@/Components/AutoResetFileButton"
import { modals } from "@mantine/modals"
import { useState } from "react"
import { IconBrandLine, IconFileImport } from "@tabler/icons-react"

export function BotProviderList(props: { workspaceId: string }) {
    const queryClient = useQueryClient()
    const list = useGetApiBotProviderList({ workspaceId: props.workspaceId })
    const [createLoading, setCreateLoading] = useState(false)
    const create_Mutation = usePostApiBotProviderCreate()
    const import_Mutation = usePostApiBotProviderImport()

    return <Stack pos="relative">
        <LoadingOverlay visible={list.isFetching} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />
        <Group>
            <BotProviderCreateButton workspaceId={props.workspaceId} onChange={async data => {
                setCreateLoading(true)
                try {
                    data.id = ""
                    data.workspaceId = props.workspaceId
                    await create_Mutation.mutateAsync({
                        params: {
                            workspaceId: props.workspaceId
                        },
                        data: data
                    })
                    queryClient.invalidateQueries({ queryKey: list.queryKey })
                    notifications.show({ message: "新增成功" })
                } catch (e) {
                    notifications.show({ message: "新增失敗", color: "red" })
                }
                setCreateLoading(false)
            }}>
                <Button leftSection={<IconBrandLine />}>
                    新增Bot串接
                </Button>
            </BotProviderCreateButton>
            <AutoResetFileButton accept="application/json" onChange={async f => {
                const text = await f?.text()
                if (text) {
                    const data = JSON.parse(text) as BotProvider
                    modals.openContextModal({
                        modal: "TextInput",
                        title: "匯入Bot串接",
                        innerProps: {
                            initText: data.name ?? "",
                            children: <>匯入類別:{data.type}</>,
                            textInputProps: {
                                label: "名稱"
                            },
                            onConfirm: async v => {
                                setCreateLoading(true)
                                data.name = v
                                try {
                                    await import_Mutation.mutateAsync({
                                        params: {
                                            workspaceId: props.workspaceId
                                        },
                                        data: {
                                            importData: data
                                        }
                                    })
                                    queryClient.invalidateQueries({ queryKey: list.queryKey })
                                    notifications.show({ message: "匯入成功" })
                                } catch (e) {
                                    notifications.show({ message: "匯入失敗", color: "red" })
                                }
                                setCreateLoading(false)
                            }
                        }
                    })
                } else {
                    notifications.show({ message: "讀取資料失敗", color: "red" })
                }
            }}>
                {(props) => <Button {...props} loading={createLoading} leftSection={<IconFileImport />}>
                    匯入
                </Button>}
            </AutoResetFileButton>
        </Group>
        <Group>
            {list.data?.data.map((botProvider, idx) => <BotProviderCard key={botProvider.id} botProvider={botProvider} />
            )}
        </Group>
    </Stack>
}